import React, { useContext } from "react";
import { FaEdit } from "react-icons/fa";
import { AuthContext } from "./../context/Auth";

const Table = ({ headers, data, onEdit, searchQuery }) => {
  const { userRole } = useContext(AuthContext);

  const filteredData = (data || []).filter((row) => {
    return Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    );
  })
    .sort((a, b) => {
      const usernameA = a.username || "";
      const usernameB = b.username || "";
      return usernameA.localeCompare(usernameB);
    });

  return (
    <div className="overflow-x-auto bg-white">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-green-600/90 text-white">
            <th className="px-4 py-2 text-left border-b border-gray-300">SN</th>
            {headers.map((header, index) => (
              <th
                key={index}
                className="px-4 py-2 coda-regular font-medium text-left border-b border-gray-300"
              >
                {header === "UserEmail" ? "Email" : header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-2 coda-regular font-medium border-b border-gray-300">
                  {index + 1}
                </td>
                <td className="px-4 py-2 coda-regular font-medium border-b border-gray-300">
                  {row.username?.length > 20
                    ? row.username.slice(0, 20) + "..."
                    : row.username}
                </td>
                <td className="px-4 py-2 font-light text-[13px] coda-regular border-b border-gray-300">
                  {row.email?.length > 40
                    ? row.email.slice(0, 20) + "..."
                    : row.email}
                </td>
                <td className="px-4 py-2 code-regular border-b font-[300] border-gray-300">
                  {row.role ? (
                    <div
                      className={`coda-regular text-xs px-2 py-1 rounded-full ${row.role.toLowerCase() === "admin"
                        ? "bg-yellow-500 text-white"
                        : "bg-green-500 text-white"
                        }`}
                    >
                      {row.role.toUpperCase()}
                    </div>
                  ) : (
                    <div className="coda-regular text-xs px-2 py-1 rounded-full bg-red-500 md:text-medium text-white">
                      Role Not Defined
                    </div>
                  )}
                </td>
                <td className="px-4 py-2 flex border-b font-medium border-gray-300">
                  <button
                    onClick={() => onEdit(row)}
                    className="px-3 py-1 text-white font-medium bg-blue-500 rounded hover:bg-blue-600 mr-2 flex items-center"
                  >
                    <FaEdit className="mr-2" /> Edit
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={headers.length + 1}
                className="px-4 py-2 text-center text-gray-500"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
